import { SITE_URL, normalizePath } from './seoMetadata.js';

const ORGANIZATION_ID = `${SITE_URL}/#organization`;
const WEBSITE_ID = `${SITE_URL}/#website`;
const SOFTWARE_ID = `${SITE_URL}/#software`;

const organization = {
  '@type': 'Organization',
  '@id': ORGANIZATION_ID,
  name: 'Clientalio',
  url: `${SITE_URL}/`,
  logo: `${SITE_URL}/images/logo_transbg.png`,
  sameAs: [
    'https://www.facebook.com/clientalio',
    'https://www.instagram.com/clientalio/',
    'https://www.youtube.com/@clientalio',
    'https://x.com/Clientalio',
    'https://www.linkedin.com/company/clientalio/'
  ]
};

const website = {
  '@type': 'WebSite',
  '@id': WEBSITE_ID,
  url: `${SITE_URL}/`,
  name: 'Clientalio',
  publisher: { '@id': ORGANIZATION_ID }
};

const software = {
  '@type': 'SoftwareApplication',
  '@id': SOFTWARE_ID,
  name: 'Clientalio',
  url: `${SITE_URL}/`,
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  description: 'Collect, manage, and publish customer testimonials that build trust and drive conversions.',
  publisher: { '@id': ORGANIZATION_ID }
};

function titleCase(value) {
  return value
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

function createBreadcrumbs(metadata) {
  const path = normalizePath(metadata.path);
  const segments = path.split('/').filter(Boolean);
  const items = [{ '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` }];

  segments.forEach((segment, index) => {
    const itemPath = `/${segments.slice(0, index + 1).join('/')}`;
    items.push({
      '@type': 'ListItem',
      position: index + 2,
      name: index === segments.length - 1 ? metadata.h1 || titleCase(segment) : titleCase(segment),
      item: `${SITE_URL}${itemPath}`
    });
  });

  return {
    '@type': 'BreadcrumbList',
    '@id': `${metadata.canonical}#breadcrumb`,
    itemListElement: items
  };
}

function createPageNode(type, metadata) {
  const node = {
    '@type': type,
    '@id': `${metadata.canonical}#${type.toLowerCase()}`,
    url: metadata.canonical,
    name: metadata.h1 || metadata.title,
    description: metadata.description,
    isPartOf: { '@id': WEBSITE_ID }
  };

  if (type === 'Article') {
    node.headline = metadata.h1 || metadata.title;
    node.mainEntityOfPage = metadata.canonical;
    node.author = { '@id': ORGANIZATION_ID };
    node.publisher = { '@id': ORGANIZATION_ID };
  }

  return node;
}

export function createStructuredData(metadata) {
  const schemaTypes = new Set(metadata.schemaTypes || []);
  const graph = [];

  if (schemaTypes.has('Organization')) graph.push(organization);
  if (schemaTypes.has('WebSite')) graph.push(website);
  if (schemaTypes.has('SoftwareApplication')) graph.push(software);

  ['CollectionPage', 'WebPage', 'Article', 'FAQPage', 'ItemList', 'VideoObject'].forEach((type) => {
    if (schemaTypes.has(type)) graph.push(createPageNode(type, metadata));
  });

  if (schemaTypes.has('BreadcrumbList')) graph.push(createBreadcrumbs(metadata));

  return {
    '@context': 'https://schema.org',
    '@graph': graph
  };
}